import { useContext, useState } from 'react'

import { FormContext } from 'Components/Hooks/ContextForm'
import SetState from 'Components/Hooks/SetState'
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { TabPanel } from 'Helpers'
import { interfaces } from 'service/interfaces'

import ContentAppBarTabs from '../Tabs/Main'

import AnexaConControl from './AnexaConControl'
import AnexaSinControl from './AnexaSinControl'
import styles from './styles'

const AvisoOblea = ({ faltantes }) => (
  <div style={{
    backgroundColor: "#fff9e5",
    border: "1px solid #ffc107",
    borderRadius: "4px",
    padding: "12px 16px",
    margin: "16px",
    display: "flex",
    alignItems: "flex-start",
    gap: "10px",
  }}>
    <span style={{ fontSize: "20px", lineHeight: 1 }}>⚠️</span>
    <div>
      <strong style={{ color: "#856404", fontSize: "14px" }}>
        No se pueden mostrar obleas
      </strong>
      <p style={{ margin: "4px 0 0", color: "#856404", fontSize: "13px" }}>
        Completá los siguientes campos en{" "}
        <em>Datos del Vehículo</em>:{" "}
        <strong>{faltantes.join(", ")}</strong>
      </p>
    </div>
  </div>
)

const SideTabs = (props) => {
  const { value, vehiculoTipo } = props
  const { formEdit } = useContext(FormContext)
  const [loading, setLoading] = useState(false)
  const [revisionConfirm, setRevisionConfirm] = useState(false)
  const revisionObleas = formEdit.vehicle.revision_obleas

  const info = formEdit.vehicle.vehiculo_info

  const camposCriticos = [
    { key: "puertas",     label: "Puertas"     },
    { key: "traccion",    label: "Tracción"    },
    { key: "transmision", label: "Transmisión" },
    { key: "combustible", label: "Combustible" },
    { key: "motor_id",    label: "Motor"       },
  ]

  const camposFaltantes = camposCriticos
    .filter(({ key }) => !info[key])
    .map(({ label }) => label)

  const mostrarAviso = camposFaltantes.length > 0

  const createDismissableSnackbar = useCustomSnackbar()

  const { state, setClose, setOpen } = SetState()

  async function handleOpen() {
    setLoading(false)
    setOpen()
  }

  const revision = async () => {
    setLoading(true)
    await interfaces.vehicleInterface
      .switchRevisionOblea(formEdit.vehicle.id)
      .then((res) => {
        createDismissableSnackbar(res.data, {
          variant: 'success',
        })
        setRevisionConfirm(true)
      })
      .catch((error) => {
        createDismissableSnackbar(error.response.data.data, {
          variant: 'error',
        })
      })
    setLoading(false)
    setClose()
  }

  const classes = styles()

  return (
    <div className={classes.style}>
      <TabPanel value={props.value} index={0}>
        {mostrarAviso && <AvisoOblea faltantes={camposFaltantes} />}
        <ContentAppBarTabs
          value={value}
          habilitar={revisionObleas}
          handleOpenRev={handleOpen}
          revisionConfirm={revisionConfirm}
          loading={loading}
          vehiculoTipo={vehiculoTipo}
        />
      </TabPanel>

      <TabPanel value={props.value} index={1}>
        <AnexaSinControl
          value={value}
          habilitar={revisionObleas}
          revisionConfirm={revisionConfirm}
        />
      </TabPanel>

      <TabPanel value={props.value} index={2}>
        <AnexaConControl
          value={value}
          habilitar={revisionObleas}
          revisionConfirm={revisionConfirm}
        />
      </TabPanel>

      {state.suspense && (
        <DialogComponent
          open={state.open}
          title="¿Desea confirmar que verificó el listado de obleas?"
          handleclose={setClose}
          widthLarge="400px"
          maxHeight
          disableBackdropClick
          disableEscapeKeyDown
          actions={
            <CancelConfirmButtons onClickCancel={() => setClose()} onClickSubmit={revision} />
          }
        />
      )}
    </div>
  )
}

export default SideTabs
